var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1719 3H12.8281C13.2697 3 13.625 3.35527 13.625 3.79688V9.375H16.5369C17.1279 9.375 17.4234 10.0889 17.0051 10.5072L11.9549 15.5607C11.7059 15.8098 11.2975 15.8098 11.0484 15.5607L5.9916 10.5072C5.57324 10.0889 5.86875 9.375 6.45977 9.375H9.375V3.79688C9.375 3.35527 9.73027 3 10.1719 3ZM20 15.4844V19.2031C20 19.6447 19.6447 20 19.2031 20H3.79688C3.35527 20 3 19.6447 3 19.2031V15.4844C3 15.0428 3.35527 14.6875 3.79688 14.6875H8.66777L10.2947 16.3145C10.9621 16.9818 12.0379 16.9818 12.7053 16.3145L14.3322 14.6875H19.2031C19.6447 14.6875 20 15.0428 20 15.4844ZM15.8828 18.4062C15.8828 18.041 15.584 17.7422 15.2188 17.7422C14.8535 17.7422 14.5547 18.041 14.5547 18.4062C14.5547 18.7715 14.8535 19.0703 15.2188 19.0703C15.584 19.0703 15.8828 18.7715 15.8828 18.4062ZM18.0078 18.4062C18.0078 18.041 17.709 17.7422 17.3438 17.7422C16.9785 17.7422 16.6797 18.041 16.6797 18.4062C16.6797 18.7715 16.9785 19.0703 17.3438 19.0703C17.709 19.0703 18.0078 18.7715 18.0078 18.4062Z",
    fill: "url(#paint0_linear_6009_1502)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6009_1502",
    x1: 15.2185,
    y1: 3.84998,
    x2: 11.2966,
    y2: 19.9504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C01519"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8b567194d4b7ec93e2fd1476eb9bec5e.svg";
export { ForwardRef as ReactComponent };